import React, { Component, PureComponent } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts from "react-highcharts";
import { number, seriesColor, deepClone, shouldUpdate, units } from "../../../../utils";
import ToggleChartSeries from '../../../ToggleChartSeries/ToggleChartSeries';

import styles from "./styles.scss";
import moment from "moment";
import HtmlParser from "react-html-parser";

let count = 0;
const idPrefix = "liveLineChart";
const dateFormat = "dddd, MMM Do, h:mm A";

const config = {
	chart: {
		animation: false,
		marginBottom: 85,
		panning: true,
		panKey: "shift",
		style: {
			fontFamily: "Helvetica"
		},
		turboThreshold: 0
	},
	credits: {
		enabled: false
	},
	title: {
		text: "Live",
		align: "left",
		margin: 60,
		style: {
			color: "#4D4D4D",
			"font-size": "20px",
			"font-weight": "600"
		}
	},
	plotOptions: {
		line: {
			dataGrouping: {
				enabled: false,
				groupAll: true
			},
			turboThreshold: 0
		}
	},

	xAxis: {
		type: "datetime",
		tickWidth: 0,
		lineColor: "#e6e6e6",
		dateTimeLabelFormats: {
			hour: "%l%P",
			day: "%e %b"
		},
		labels: {
			y: 30,
			style: {
				fontSize: "14px",
				color: "#999"
			}
		}
	},
	legend: {
		floating: false,
		itemStyle: {
			color: "#999",
			fontWeight: "normal",
			fontSize: "14px"
		},
		align: "center",
		verticalAlign: "bottom",
		layout: "horizontal"
	},
	series: []
};

@CSSModules(styles, { allowMultiple: true })
class ReportLiveLineChart extends Component {
	constructor(props) {
		super(props);
		this.chart = React.createRef();
		this.config = deepClone(config);
		this.config.title.text = this.props.component.chartTitle || this.config.title.text;
	}

	render() {
        return (
            <div>
                <ReactHighcharts derp="live-chart" config={this.config} ref={this.chart} isPureConfig={true} />
                <ToggleChartSeries chart={this.chart} />
            </div>
        ) 
	}

	setup() {
		const chart = this.chart.current.getChart();
		if (chart) {
			this.props.startLiveData(this.props.id, this.props.component, chart, this.props.onLoadComplete);
			setTimeout(() => {
			   if(chart) {
				  chart.reflow();
				  chart.redraw();
			   }
			}, 100);
		}
	}

	componentWillUnmount() {
		this.props.stopLiveData(this.props.id);
    }
    
    componentDidMount() {
		this.setup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.setup();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
    }
}

const bindAction = dispatch => {
	return {
		startLiveData: (id, component, chart, onLoadComplete) => dispatch(actions.startLiveData(id, component, chart, onLoadComplete)),
		stopLiveData: id => dispatch(actions.stopLiveData(id))
	};
};

const mapStateToProps = (state, ownProps) => ({
	chartData: state.livelinechart.instances[ownProps.id],
	hasChartData: !!state.livelinechart.instances[ownProps.id]
});

//do this to merge classes
export default class extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
		};
		this.id = idPrefix + count;
		count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(
				mapStateToProps,
				bindAction
			)(ReportLiveLineChart)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Charts/ReportLiveLineChart/ReportLiveLineChart.js